import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/images/logo-jsh.png'


const _withScopeId = n => (_pushScopeId("data-v-791ab0e1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-form-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "jsh",
    width: "100"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "login-form-title" }, " 巨商汇工作台 "),
  /*#__PURE__*/_createElementVNode("div", null, " 技术服务于人类 ")
], -1))

import { ref, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { ValidatedError } from '@arco-design/web-vue/es/form/interface'
import { useHttp } from '@/plugins/http'
import { Api } from '@/apis'
import { LoginRes } from '../login.interface'
import { Message } from '@arco-design/web-vue'
import { isProdRunEnv, setToken, setRefreshToken } from '@/utils'
import { useAppStore, useUserStore } from '@/store'
import jwtDecode from 'jwt-decode'
import { UserState } from '@/store/modules/user/user.interface'
import { Menu } from '@/store/modules/app/app.interface'


export default /*#__PURE__*/_defineComponent({
  __name: 'login-form',
  setup(__props) {

const router = useRouter()
const http = useHttp()
const app = useAppStore()
const user = useUserStore()
const { fallbackPath } = app

const errorMessage = ref('')
// const { loading, setLoading } = useLoading()
const userInfo = reactive({
  username: '',
  passwd: ''
})

function getFirstMenu (menuList: Menu[]): Menu {
  if (menuList[0].children?.length) {
    return getFirstMenu(menuList[0].children)
  } else {
    return menuList[0]
  }
}

const handleSubmit = async ({
  errors,
  values
}: {
  errors: Record<string, ValidatedError> | undefined;
  values: any;
}) => {
  if (!errors) {
    // setLoading(true)
    try {
      const res = await http.post<LoginRes>(Api.login, values)
      if (res.data.success) {
        const { accessToken, refreshToken, menuList, authList } = res.data.data
        app.$patch({
          fallbackPath: null,
          menuList,
          authList
        })
        localStorage.setItem('menuList', JSON.stringify(menuList))
        localStorage.setItem('authList', JSON.stringify(authList))
        Message.success('欢迎使用')
        setToken(accessToken)
        setRefreshToken(refreshToken)
        const data = jwtDecode<UserState>(accessToken)
        user.$patch(data)
        localStorage.setItem('userInfo', JSON.stringify(data))

        if (isProdRunEnv) {
          router.push('/ai-helper')
          return
        }
        if (authList.length === 0) {
          router.push('/403')
        }
        router.push(fallbackPath || getFirstMenu(menuList).url)
      } else {
        Message.error('用户名或密码错误')
      }
    } catch (err) {
      errorMessage.value = (err as Error).message
    } finally {
      // setLoading(false)
    }
  }
}
const setRememberPassword = () => {
  //
}

return (_ctx: any,_cache: any) => {
  const _component_icon_user = _resolveComponent("icon-user")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_icon_lock = _resolveComponent("icon-lock")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_a_form, {
      ref: "loginForm",
      model: userInfo,
      class: "login-form",
      layout: "vertical",
      onSubmit: handleSubmit,
      size: "large"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, {
          field: "username",
          label: "用户名",
          rules: [{ required: true, message: '用户名不能为空' }],
          "validate-trigger": ['change', 'blur']
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: userInfo.username,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userInfo.username) = $event)),
              placeholder: "请输入用户名"
            }, {
              prefix: _withCtx(() => [
                _createVNode(_component_icon_user)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "passwd",
          label: "密码",
          rules: [{ required: true, message: '密码不能为空' }],
          "validate-trigger": ['change', 'blur']
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_password, {
              modelValue: userInfo.passwd,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((userInfo.passwd) = $event)),
              placeholder: "请输入密码",
              "allow-clear": ""
            }, {
              prefix: _withCtx(() => [
                _createVNode(_component_icon_lock)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              "html-type": "submit",
              long: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 登录 ")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}
}

})